module.exports = __webpack_public_path__ + "img/writing_music-hover.cd0c828c.svg";